// For Custom Javascript

// Newsletter form validation

function validateForm(email, button) {
  var subemail = document.getElementById(email);
  var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  if (re.test(subemail.value.toLowerCase()) == true) {
    $("#" + email).addClass("email-valid");
    $("#" + button).addClass("email-valid");
    return true;
  }
  else {
    $("#" + email).removeClass("email-valid");
    $("#" + button).removeClass("email-valid");
    return false;
  }
}
